<template>
    <div v-if="feedback !== null">
        <div class="row">
            <div class="col-12">
                <div class="form-group m-form__group">
                    <div class="form-group m-form__group">
                        <label for="status">フィードバックのステータス</label>
                        <select
                            v-model="feedback.status"
                            id="status"
                            class="form-control feedbackStatus"
                            :class="{ 'is-invalid' : errors.status }">
                            <option :value="null">選択してください</option>
                            <option
                                v-for="feedbackStatus in feedbackStatusAll"
                                :value="feedbackStatus.value">
                                {{ feedbackStatus.text }}
                            </option>
                        </select>
                        <div
                            v-if="errors.status"
                            class="invalid-feedback d-block mt-1">
                            {{ errors.status[0] }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group m-form__group">
                    <label for="opinion">業務配慮についての意見</label>
                    <b-form-textarea
                        v-model="feedback.opinion"
                        :rows="4"
                        :max-rows="10"
                        :class="{ 'is-invalid' : errors.opinion }"
                        id="opinion">
                    </b-form-textarea>
                    <div
                        v-if="errors.opinion"
                        class="invalid-feedback d-block mt-1">
                        {{ errors.opinion[0] }}
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group m-form__group">
                    <label for="special_notes">特記事項</label>
                    <b-form-textarea
                        v-model="feedback.special_notes"
                        :rows="4"
                        :max-rows="10"
                        :class="{ 'is-invalid' : errors.special_notes }"
                        id="special_notes">
                    </b-form-textarea>
                    <div
                        v-if="errors.special_notes"
                        class="invalid-feedback d-block mt-1">
                        {{ errors.special_notes[0] }}
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group m-form__group">
                    <label for="next_schedule">次回相談予定</label>
                    <input
                        v-model="feedback.next_schedule"
                        class="form-control m-input"
                        :class="{ 'is-invalid' : errors.next_schedule }"
                        id="next_schedule"
                        type="text">
                    <div
                        v-if="errors.next_schedule"
                        class="invalid-feedback d-block mt-1">
                        {{ errors.next_schedule[0] }}
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3 d-flex justify-content-between align-items-center">
            <div
                v-if="!feedback.published_at"
                class="text-muted">
                <div>記録未公開</div>
            </div>
            <div v-else>
                <div class="yokumiru-dark-green">記録公開済</div>
                <div class="text-muted">公開日時:&nbsp;{{ publishedAt }}</div>
            </div>

            <div class="text-right">
                <button
                    class="btn btn-yokumiru-orange mr-1"
                    :disabled="inProgress"
                    @click="update">
                    保存
                </button>
                <button
                    v-if="canPublish"
                    class="btn btn-yokumiru-dark-green"
                    :disabled="inProgress"
                    @click="publish">
                    保存して公開
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import moment from 'moment-timezone'

    export default {
        props: {
            consultation: {
                type: Object,
                required: true,
            },
            consultationFeedback: {
                type: Object,
                required: true,
            },
        },

        data: function() {
            return {
                helper: YokumiruHelper,
                feedback: null,
                medicalRecordBody: null,
                inProgress: false,
                feedbackStatusAll: constants.consultation_feedback.all,
                errors: {},
            };
        },

        computed: {
            /**
             * 公開日フォーマット
             *
             * @return {string}
             */
            publishedAt: function () {
                if (this.feedback && this.feedback.published_at) {
                    return moment(this.feedback.published_at).locale('ja').format('YYYY年M月D日(ddd) HH:mm')
                }
                return ''
            },

            /**
             * 記録公開可能判定
             *
             * @return {boolean}
             */
            canPublish: function () {
                if (!this.feedback) {
                    return false
                }
                return !this.feedback.published_at && constants.consultations.canPublishAll.includes(this.consultation.status)
            }
        },

        created: function() {
            this.feedback = { ...this.consultationFeedback }
            console.log(this.feedback)
            bus.$on('consultation-feedback-published', this.fetchConsultation)
            bus.$on('medical-record-debounce', this.syncMedicalRecordBody)
        },

        beforeDestroy: function() {
            bus.$off('consultation-feedback-published')
            bus.$off('medical-record-debounce')
        },

        methods: {
            /**
             * 相談記録の内容を同期
             *
             * @param body
             */
            syncMedicalRecordBody: function (body) {
                this.medicalRecordBody = body
            },

            /**
             * 法人フィードバック更新
             */
            update: async function() {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = `${constants.doctor.consultation_feedback.endpoint.base}/${this.feedback.id}`

                await axios.put(endpoint, this.feedback)
                    .then(({data}) => {
                        this.feedback = data.data
                        this.errors = {}
                        bus.$emit('alert-success', 'フィードバックを保存しました。')
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                        else {
                            bus.$emit('alert-danger', '保存に失敗しました。時間を置いて再度お試しください。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * 相談記録／法人フィードバック公開
             */
            publish: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = `${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/publish`
                const data = {
                    body: this.medicalRecordBody,
                    status: this.feedback.status,
                    opinion: this.feedback.opinion,
                    special_notes: this.feedback.special_notes,
                    next_schedule: this.feedback.next_schedule,
                }

                await axios.put(endpoint, data)
                    .then(() => {
                        this.errors = {}
                        this.fetchConsultation()
                        bus.$emit('consultation-feedback-published')
                        bus.$emit('alert-success', '記録を公開しました。')
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors

                            if (this.errors.body) {
                                bus.$emit('alert-danger', `${this.$locale.consultation_host}記録が未入力のため公開できません。`)
                                bus.$emit('medical-record-validation-failed')
                            } else {
                                bus.$emit('alert-danger')
                            }
                        }
                        else {
                            bus.$emit('alert-danger', '保存に失敗しました。時間を置いて再度お試しください。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * 診療予約の取得
             */
            fetchConsultation: function () {
                axios.get(`${constants.doctor.consultations.endpoint.base}/${this.consultation.id}`)
                    .then(({data}) => {
                        this.feedback = data.consultation_feedback
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>
.feedbackStatus {
    max-width: 240px;
}
</style>
